angular.module("otherDocumentation.components", []).component("otherDocumentation", {
    templateUrl: "ng/components/munAuthorization/otherDocumentation/otherDocumentation.view.html",
    bindings: {
        documentazione: "=",
        docCheckList: "&"
    },
    controllerAs: "otherDocCtrl",
    controller: function OtherDocumentation($typeDomainService) {
        var self = this;

        self.supportModel = [];
        self.$onInit = function () {
            if (self.documentazione.length === 0) {
                $typeDomainService.getDomainSet("RI_POSTVENDITA","CHECKBOX_CC").then(function (response){
                    for (const element of response.domainList) {
                        var document = {};
                        document.name = element.name;
                        document.description = element.description;
                        document.value = element.value;
                        document.id = element.value;
                        document.selected = element.selected || false;
                        self.documentazione.push(document);
                    }
                })
            }
        };

        self.onCheckboxChange = function (el) {
            el.selected = !el.selected;

            self.docCheckList({
                docSelected: self.documentazione
            });
        }
    }
});